module.exports = __webpack_public_path__ + "static/media/undraw_To_do_list_re_9nt7.d329d449.svg";